import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ExamsReportFiltersDTO } from "../../schema/Exam/report/ExamsReportFiltersDTO";
import { ExamsReportRequestDTO } from "../../schema/Exam/report/ExamsReportRequestDTO";

@Injectable({
    providedIn: "root"
})
export class ApiExamsReportService {
    private relativePath: string;

    constructor(private httpClient: HttpClient) {
        this.relativePath = `${environment.exams.url}/api/v1/TrialExams/report/request`;
    }

    public RequestReport(filters: ExamsReportFiltersDTO): Observable<unknown> {
        return this.httpClient.post(this.relativePath, filters);
    }

    public GetRequestById(id: string): Observable<ExamsReportRequestDTO> {
        return this.httpClient.get<ExamsReportRequestDTO>(`${this.relativePath}/${id}`);
    }
}
